<template>
  <div class="ai-visibility-paused-schedule-banner">
    <div class="ai-visibility-paused-schedule-banner__icon">
      <span class="material-icons-outlined">pause</span>
    </div>

    <div class="ai-visibility-paused-schedule-banner__copy">
      <div class="ai-visibility-paused-schedule-banner__title">
        Schedule paused
      </div>
      <div class="ai-visibility-paused-schedule-banner__body">
        This report won't refresh automatically and won't use credits. Your
        latest data stays available. Resume anytime.
      </div>
    </div>

    <button
      type="button"
      class="ai-visibility-paused-schedule-banner__resume"
      :disabled="saving"
      @click="$emit('resume')"
    >
      {{ saving ? 'Resuming...' : resumeLabel }}
    </button>
  </div>
</template>

<script>
function normalizeFrequency(value) {
  const text = String(value || '').trim()
  if (!text) {
    return 'weekly'
  }
  return text.toLowerCase()
}

export default {
  name: 'PausedScheduleBanner',
  props: {
    tracker: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resumeLabel() {
      return `Resume ${normalizeFrequency(this.tracker.refreshFrequency)} refresh`
    },
  },
}
</script>

<style scoped lang="scss">

.ai-visibility-paused-schedule-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 12px;
  background: var(--v-gray7Color-base);
  margin: 22px 0;
  padding: 14px 18px;
}

.ai-visibility-paused-schedule-banner__icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 9px;
  background: var(--v-cardBg-base);
  color: var(--v-darkGrayColor-base);
}

.ai-visibility-paused-schedule-banner__icon span {
  font-size: 18px;
}

.ai-visibility-paused-schedule-banner__copy {
  min-width: 0;
  flex: 1;
}

.ai-visibility-paused-schedule-banner__title {
  color: var(--v-mainColor-base);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
}

.ai-visibility-paused-schedule-banner__body {
  color: var(--v-darkGrayColor-base);
  font-size: 13px;
  line-height: 1.45;
}

.ai-visibility-paused-schedule-banner__resume {
  min-height: 36px;
  flex: 0 0 auto;
  border: 0;
  border-radius: 8px;
  background: var(--v-profileAnchorColor-base);
  color: var(--v-whiteColor-base);
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  padding: 0 14px;
}

.ai-visibility-paused-schedule-banner__resume:hover,
.ai-visibility-paused-schedule-banner__resume:focus {
  background: var(--v-mainColor-base);
  outline: none;
}

.ai-visibility-paused-schedule-banner__resume:disabled {
  cursor: default;
  opacity: 0.55;
}

@media (max-width: 720px) {
  .ai-visibility-paused-schedule-banner {
    align-items: flex-start;
    flex-direction: column;
  }

  .ai-visibility-paused-schedule-banner__resume {
    width: 100%;
  }
}

</style>
